import type { BuildingSocietySavingsSettingsDetailsCountryConfig } from '../../BuildingSocietySavingsSettingsDetailsConfig';

export const savingsSettingsDetails: BuildingSocietySavingsSettingsDetailsCountryConfig = {
    displayAgreementNumber: true,
};
